import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

import { LoginShape, ForgotPasswordShape, SetPasswordShape, VerifyShape } from "../interfaces";

export default {
  login: (payload: LoginShape) => request(METHODS.POST, API.AUTH.LOGIN)(payload),
  verify: (payload: VerifyShape) => request(METHODS.POST, API.AUTH.VERIFY)(payload),
  setPassword: (payload: SetPasswordShape) => request(METHODS.POST, API.AUTH.SET_PASSWORD)(payload),
  forgotPassword: ({ login }: ForgotPasswordShape) => request(METHODS.POST, API.AUTH.FORGOT_PASSWORD)({ login }),
  registration: (payload: unknown) => request(METHODS.POST, API.AUTH.REGISTER)(payload),
};
